export default function References() {
  const references = [
    {
      name: 'RESTAURANT',
      category: 'Restauration',
      image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20restaurant%20interior%20with%20modern%20lighting%20fixtures%20sophisticated%20electrical%20installations%20high-end%20dining%20space%20professional%20photography%20clean%20simple%20background%20premium%20ambiance&width=600&height=400&seq=restaurant-ref-001&orientation=landscape',
      description: 'Installation électrique complète et système de ventilation pour restaurant gastronomique'
    },
    {
      name: 'CENTRE COMMERCIAL',
      category: 'Commerce',
      image: 'https://readdy.ai/api/search-image?query=modern%20shopping%20mall%20interior%20with%20advanced%20electrical%20systems%20contemporary%20commercial%20architecture%20retail%20space%20professional%20photography%20clean%20simple%20background%20Geneva%20shopping%20center&width=600&height=400&seq=centre-commercial-ref-002&orientation=landscape',
      description: 'Installations électriques, ventilation et climatisation pour centre commercial'
    },
    {
      name: 'VILLE DE GENÈVE',
      category: 'Secteur Public',
      image: 'https://readdy.ai/api/search-image?query=Geneva%20city%20hall%20official%20government%20building%20modern%20public%20infrastructure%20electrical%20systems%20Swiss%20architecture%20professional%20photography%20clean%20simple%20background%20administrative%20building&width=600&height=400&seq=ville-geneve-ref-003&orientation=landscape',
      description: 'Maintenance et mise aux normes OIBT des installations électriques municipales'
    },
    {
      name: 'APPARTEMENTS',
      category: 'Résidentiel',
      image: 'https://readdy.ai/api/search-image?query=luxury%20modern%20apartment%20interior%20with%20elegant%20lighting%20smart%20home%20automation%20high-end%20residential%20electrical%20installations%20contemporary%20design%20professional%20photography%20clean%20simple%20background%20premium%20living%20space&width=600&height=400&seq=appartement-ref-004&orientation=landscape',
      description: 'Installations électriques, domotique et chauffage pour appartements haut de gamme'
    },
    {
      name: 'VILLAS PRIVÉES',
      category: 'Résidentiel Premium',
      image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20villa%20exterior%20with%20sophisticated%20outdoor%20lighting%20premium%20residential%20property%20elegant%20architecture%20professional%20photography%20clean%20simple%20background%20high-end%20home%20Geneva%20style&width=600&height=400&seq=villa-ref-005&orientation=landscape',
      description: 'Solutions CVSE complètes pour villas de prestige avec pompes à chaleur et domotique'
    },
    {
      name: 'BÂTIMENTS COMMERCIAUX',
      category: 'Commercial',
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20with%20advanced%20electrical%20systems%20contemporary%20architecture%20business%20infrastructure%20professional%20photography%20clean%20simple%20background%20corporate%20real%20estate%20Geneva&width=600&height=400&seq=batiment-commercial-ref-006&orientation=landscape',
      description: 'Installations électriques industrielles, ventilation et systèmes de sécurité'
    },
    {
      name: 'IMMEUBLES RÉSIDENTIELS',
      category: 'Immobilier',
      image: 'https://readdy.ai/api/search-image?query=modern%20residential%20apartment%20building%20with%20quality%20electrical%20installations%20contemporary%20Swiss%20architecture%20multi-family%20housing%20professional%20photography%20clean%20simple%20background%20urban%20living%20Geneva&width=600&height=400&seq=immeuble-ref-007&orientation=landscape',
      description: 'Rénovation complète des installations CVSE et mise en conformité NIBT'
    }
  ];

  const stats = [
    {
      value: '150+',
      label: 'Projets Réalisés'
    },
    {
      value: '1 an',
      label: 'D\'Expérience depuis 09/2024'
    },
    {
      value: '98%',
      label: 'Clients Satisfaits'
    },
    {
      value: '24/7',
      label: 'Service d\'Urgence'
    }
  ];

  return (
    <section id="references" className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Nos Références</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Ils Nous Font Confiance
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Des projets prestigieux réalisés à Genève et en Suisse romande pour des clients exigeants.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {references.map((reference, index) => (
            <div 
              key={index} 
              className="group bg-white rounded-xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl hover:border-teal-200 transition-all duration-300"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src={reference.image}
                  alt={reference.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-3 py-1 bg-teal-600 text-white text-xs font-semibold rounded-full mb-2">
                    {reference.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {reference.name}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {reference.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border border-teal-100">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">20+</div>
              <div className="text-gray-600 text-sm">Projets Réalisés</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">99%</div>
              <div className="text-gray-600 font-medium">Clients Satisfaits</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">24/7</div>
              <div className="text-gray-600 font-medium">Service d'Urgence</div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Rejoignez nos clients satisfaits et bénéficiez de notre expertise CVSE reconnue à Genève
          </p>
          <a
            href="#contact"
            className="inline-block rounded-full bg-teal-600 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-teal-700 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Demander un Devis Gratuit
          </a>
        </div>
      </div>
    </section>
  );
}
